module.exports = __webpack_public_path__ + "img/logo-sm.9e75a2ea.png";